"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/** See https://github.com/KyleAMathews/deepmerge for webpack bug */
var createMuiTheme_1 = tslib_1.__importDefault(require("@material-ui/core/styles/createMuiTheme"));
var deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
var styles_1 = require("@material-ui/core/styles");
var styles_2 = require("@material-ui/core/styles");
exports.createStyles = styles_2.createStyles;
exports.createGenerateClassName = styles_2.createGenerateClassName;
exports.ThemeProvider = styles_2.MuiThemeProvider;
/** @todo implement own version of this */
/** Try to keep in-line with Material-UI - see  https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/ */
exports.roboto = "Roboto, Helvetica, Arial, sans-serif;";
var defaultTextColor = "#f0f0f0";
var defaultSpacing = 8;
/** Spacing is around 0.5em */
var standardFont = {
    fontFamily: exports.roboto,
    fontWeight: 300,
    fontSize: 14,
    color: "inherit"
};
/** @todo a large type hack to get my own Theme defs */
exports.withStyles = function (style, options) {
    return styles_1.withStyles(style, options);
};
exports.defaultOptions = ({
    spacing: {
        unit: defaultSpacing
    },
    typography: {
        useNextVariants: true,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        title: tslib_1.__assign({}, standardFont, { fontWeight: 300, fontSize: "30px" }),
        /** @todo consider removing these custom typography options */
        strong: tslib_1.__assign({}, standardFont, { fontWeight: 500 }),
        subtitle: tslib_1.__assign({}, standardFont, { fontSize: defaultSpacing * 2 + "px" }),
        section: tslib_1.__assign({}, standardFont, { fontWeight: 300, fontSize: 24 }),
    },
    palette: {
        backgroundColor: "#fff",
        text: {
            primary: "#444",
            secondary: "#888",
            disabled: "#aaa",
            hint: "#000"
        },
        primary: {
            main: "#0b3297",
            contrastText: "#fff"
        },
        secondary: {
            main: "#15bad2",
            contrastText: "#fff"
        },
        /** Actions and status */
        highlight: {
            main: "#fafafa",
            contrastText: "#000"
        },
        error: {
            main: "#BF3220",
            contrastText: "#fff"
        },
        warning: {
            main: "#ffcd0d",
            contrastText: "#fff"
        },
        /** From signatu design */
        positive: {
            main: "#0b3297",
            contrastText: "#fff"
        },
        calm: {
            main: "#15bad2",
            contrastText: "#fff"
        },
        balanced: {
            main: "#0bb064",
            contrastText: "#fff"
        },
        assertive: {
            main: "#BF3220",
            contrastText: "#fff"
        },
        attention: {
            main: "#cb2971",
            contrastText: "#fff"
        },
        symbol: {
            main: "#ffcd0d",
            contrastText: "#fff"
        }
    }
});
var createTheme = function (options) {
    var opts = options ? deepmerge_1.default(exports.defaultOptions, options) : exports.defaultOptions;
    return createMuiTheme_1.default(opts);
};
exports.default = createTheme;
//# sourceMappingURL=createTheme.js.map